import {useFormContext} from "react-hook-form";
import {Label, Radio} from "theme-ui";
import React from "react";
import {bool, string} from "prop-types";

function RadioField({label, value, name, disabled, ...rest}){
    const {getValues, register} = useFormContext();
    const selected = getValues(name);
    const variant = disabled && selected === value ? 'radio.disabled.active' : null;
    return(
        <>
            <Label variant="radio">
                <Radio
                    variant={variant}
                    disabled={disabled}
                    value={value}
                    readOnly={disabled}
                    {...register(name)}
                /> {label}
            </Label>
        </>
    )
}

export const RadioFieldPropTypes = {
    label: string,
    value: string,
    name: string.isRequired,
    disabled: bool
}

RadioField.propTypes = RadioFieldPropTypes;

export default RadioField;